import styled from 'styled-components';

export const CustomFieldRowStyles = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	padding: 0.5rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
	border-radius: 0.25rem;
	min-width: 0;

	> .content {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		gap: 0.5rem;
		min-width: 0;
	}

	.label {
		max-width: 45%;
		min-width: 0;
	}

	.value {
		max-width: 55%;
		min-width: 0;
		margin-left: auto;
		text-align: left;
	}
`;
